import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import throttle from 'lodash/throttle';
import logger from 'redux-logger';

import { loadState, saveState } from './localStorage';
import rootReducer from './reducers';
import rootSaga from './sagas';

const isProd = process.env.NODE_ENV === 'production';
const persistedState = loadState();

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();
const store = createStore(
    rootReducer,
    persistedState,
    isProd
        ? applyMiddleware(sagaMiddleware)
        : composeWithDevTools(applyMiddleware(sagaMiddleware, logger))
);

// then run the saga
sagaMiddleware.run(rootSaga);

store.subscribe(
    throttle(() => {
        const state = store.getState();
        saveState({
            // config: state.config,
            general: state.general,
            users: {
                byId: state.users.byId,
                authUser: state.users.authUser,
            },
            sites: {
                byId: state.sites.byId,
                allSites: state.sites.allSites,
                buildingId: state.sites.buildingId,
            },
        });
    }),
    1000
);

export default store;
